module.exports = __webpack_public_path__ + "static/media/arrow.5eca749f.svg";